import styles from "./AuthLayoutSubmitButton.module.css";
import { Button, ThemeProvider, createTheme, styled } from "@mui/material";

interface ButtonProps{
  title: string;
  disableBtn: boolean;
}
const theme= createTheme({
  palette:{
    primary:{
      main: '#5D75F8'
    }
  }
})
const AuthLayoutSubmitButton = ({title,disableBtn}: ButtonProps) => {
  const CustomButton = styled(Button)(()=>({
   '&.MuiButton-root':{
      textTransform: "capitalize",
      fontWeight: "bold",
   }
  }))
  return (
    <ThemeProvider theme={theme}>
    <div className={styles.button}>
      <CustomButton
      disabled={disableBtn}
      type={"submit"}
       variant={"contained"} 
       disableElevation
       color={"primary"}
       disableRipple
       sx={{
        borderRadius: 0,
        alignSelf: "stretch",
        fontSize: "var(--sub-s-h2-16-semibold-center-size)",
        color: "var(--neutral-white)",
        fontFamily: "var(--body-b3-12-semibold-left)",
        height: "52px"
       }}
       >{title}</CustomButton>
    </div>
    </ThemeProvider>
  );
};

export default AuthLayoutSubmitButton;

